import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import NewUserMenu from "./NewUserMenu";

const NAV_LINKS = [
    { label: "Juegos", to: "/games" },
    { label: "Partidas Activas", to: "/active-matches" },
    { label: "Próximamente", to: "/next-games" },
    { label: "Nosotros" },
    { label: "Soporte" },
];

export default function NewHeader() {
    const { isAuthenticated, user, logout, authStateVersion } = useAuth();
    const location = useLocation();

    useEffect(() => {
        console.log("NewHeader re-render", { isAuthenticated, user, authStateVersion });
    }, [isAuthenticated, user, authStateVersion]);

    const [scrolled, setScrolled] = React.useState(false);

    React.useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 2);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header className="fixed top-0 inset-x-0 z-50 bg-transparent">
            <div className="relative">
                {/* Overlay de gradiente */}
                <div
                    className={`pointer-events-none absolute inset-0 z-0 transition-opacity duration-300 ${
                        scrolled ? "opacity-100" : "opacity-0"
                    }`}
                    style={{
                        background:
                            "linear-gradient(to bottom, #122436 0%, rgba(18,36,54,0.85) 32%, rgba(18,36,54,0.65) 55%, rgba(18,36,54,0.45) 70%, rgba(18,36,54,0) 100%)",
                    }}
                />

                {/* Grid con más espacio entre columnas */}
                <nav className="relative z-10 mx-auto w-full max-w-[calc(100%-100px)] px-4 sm:px-6 lg:px-8 h-16 grid grid-cols-[auto,1fr,auto] gap-8 lg:gap-12 items-center text-white">
                    {/* IZQUIERDA: Logo */}
                    <div className="min-w-[160px] sm:min-w-[190px] lg:min-w-[220px] flex items-center">
                        <Link to="/" className="inline-flex items-center">
                            <img
                                src="/images/logos/logo-text2.png"
                                alt="Mano Ganadora"
                                className="h-12 md:h-14 lg:h-16 w-auto block select-none"
                                draggable={false}
                            />
                        </Link>
                    </div>

                    {/* CENTRO: Links */}
                    <div className="hidden md:flex justify-center">
                        <ul className="flex items-center gap-8">
                            {NAV_LINKS.map((it) => {
                                const isActive = it.to && location.pathname === it.to;
                                const linkClasses = `
                                uppercase tracking-wide text-sm font-semibold 
                                transition-all 
                                ${isActive
                                    ? 'text-[#fce503] underline decoration-[#fce503] decoration-2 underline-offset-4'
                                    : 'text-white/90 hover:text-[#fce503] hover:underline hover:decoration-[#fce503] hover:decoration-2 hover:underline-offset-4'
                                }
                            `;

                                return (
                                    <li key={it.label}>
                                        {it.to ? (
                                            <Link to={it.to} className={linkClasses}>
                                                {it.label}
                                            </Link>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={(e) => e.preventDefault()}
                                                className={linkClasses}
                                            >
                                                {it.label}
                                            </button>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {/* DERECHA: Auth / Menús */}
                    <div className="flex items-center justify-end">
                        {isAuthenticated ? (
                            <NewUserMenu user={user} onLogout={logout} />
                        ) : (
                            <div className="flex items-center gap-3">
                                <Link
                                    to="/login"
                                    className="px-4 py-2 rounded-full text-sm font-medium text-white/90 hover:text-white transition-colors"
                                >
                                    Ingresar
                                </Link>
                                <Link
                                    to="/register"
                                    className="px-4 py-2 rounded-full text-sm font-semibold bg-[#2F86F6] hover:bg-[#4A99FF] text-white transition-colors"
                                >
                                    Registrarse
                                </Link>
                            </div>
                        )}
                    </div>
                </nav>
            </div>
        </header>
    );
}